import { createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { getAboutPage, getCoreValues } from '~/lib/content/content'
import { bodyClass } from '~/components/ui/BodyText'
import { Container } from '~/components/ui/Container'
import { DonateSignupBand } from '~/components/sections/DonateSignupBand'
import {
  MissionStatement,
  ReportViolationNote,
} from '~/components/sections/CoreValuesCopy'
import { Eyebrow } from '~/components/ui/Eyebrow'
import { PageTitle, pageTitleClass } from '~/components/ui/PageTitle'
import { PageHero } from '~/components/ui/PageHero'
import { SectionHeading } from '~/components/ui/SectionHeading'

const TITLE = 'Mission & Values | Direct Action Everywhere'
const DESCRIPTION =
  'Our mission is to achieve revolutionary social and political change for animals in one generation. Read the core values that guide DxE.'

export const Route = createFileRoute('/core-values')({
  // The mission comes from content/about.json, shared with /about-us.
  loader: async () => ({
    mission: (await getAboutPage()).mission,
    coreValues: await getCoreValues(),
  }),
  headers: () => cacheHeaders.content,
  head: () => pageMeta({ title: TITLE, description: DESCRIPTION }),
  component: CoreValues,
})

function CoreValues() {
  const { mission, coreValues } = Route.useLoaderData()
  return (
    <>
      <PageHero bottom="page">
        <Container width="narrow">
          <PageTitle size="md" className="mb-5">
            Mission &amp; Values of Direct Action Everywhere
          </PageTitle>
          <Eyebrow>our mission</Eyebrow>
          <SectionHeading size="md" className="mt-2.5 mb-2.5">
            {mission.heading}
          </SectionHeading>
          <MissionStatement
            paragraphs={mission.paragraphs}
            className={bodyClass}
          />
        </Container>
      </PageHero>

      <section className="bg-surface-alt py-10 md:py-[30px]">
        <Container width="narrow">
          <h2 className={`mb-[15px] ${pageTitleClass('md')}`}>Values</h2>
          {coreValues.map((v) => (
            <div key={v.strong}>
              <SectionHeading size="md" className="mt-5 mb-2.5">
                {v.before}
                <strong>{v.strong}</strong>
                {v.after}.
              </SectionHeading>
              {v.paragraphs.map((p) => (
                <p key={p} className={`${bodyClass} mb-5`}>
                  {p}
                </p>
              ))}
            </div>
          ))}
        </Container>
      </section>

      <section className="bg-surface py-5 text-center">
        <Container className="max-w-[740px]">
          <ReportViolationNote className={`${bodyClass} m-0`} />
        </Container>
      </section>

      <DonateSignupBand />
    </>
  )
}
